import { IProduct, IProductFileWithFile } from "@evennt-tech/api-v2-core";

export const collectProductFiles = (
  product: IProduct
): IProductFileWithFile[] =>
  (product.productFiles ?? []).flatMap((productFile) =>
    productFile.file
      ? [
          {
            ...productFile,
            file: productFile.file,
            signedUrl: productFile.file.url,
          } as IProductFileWithFile,
        ]
      : []
  );
